import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LabelService {
  private apiUrl = `${environment.apiUrl}/label`;

  constructor(private http: HttpClient, private router: Router) { }

  getTodayPrintCount(): Observable<{ date: string; count: number; timeZone: string }> {
    return this.http.get<{ date: string; count: number; timeZone: string }>(
      `${this.apiUrl}/print-count/today`,
      { observe: 'response' }
    ).pipe(
      map((response: HttpResponse<{ date: string; count: number; timeZone: string }>) => response.body!)
    );
  }

  print(shipmentIds: number[]): Observable<any> {
    const raw = JSON.stringify(shipmentIds);

    return this.http.post(`${this.apiUrl}/print`, raw, { observe: 'response' }).pipe(
      map(response => {
        if (response.status !== 200) {
          throw new Error('Erro ao imprimir etiquetas.');
        }
        return response.body;
      })
    );
  }

  printByOrder(orderId: any): Observable<any> {
    const url = `${this.apiUrl}?&orderId=${orderId}`;

    return this.http.get(url, { observe: 'response' }).pipe(
      map(response => {
        if (response.status !== 200) {
          throw new Error('Erro ao imprimir etiqueta.');
        }
        return response.body;
      })
    );
  }

  createLog(saleNumber: number, action: string, dateTime: string, observation: string, isError: boolean = false, errorCode?: number): Observable<any> {
    const body: any = {
      saleNumber,
      action,
      dateTime,
      observation,
      type: isError ? 'error' : 'success'
    };

    if (errorCode !== undefined && errorCode !== null) {
      body.errorCode = errorCode;
    }

    return this.http.post(`${this.apiUrl}/logs`, body, { observe: 'response' }).pipe(
      map(response => {
        if (response.status !== 200 && response.status !== 201) {
          throw new Error('Erro ao salvar log.');
        }
        return response.body;
      })
    );
  }

  getLogs(skip: number, limit: number): Observable<{ items: any[], total: number }> {
    const url = `${this.apiUrl}/logs?skip=${skip}&limit=${limit}`;

    return this.http.get<{ items: any[], total: number }>(url, { observe: 'response' }).pipe(
      map(response => {
        if (response.status !== 200) {
          throw new Error('Erro ao buscar logs.');
        }
        return response.body || { items: [], total: 0 };
      })
    );
  }
}
